import CallsPage from "@/pages/sidebar/interact/calls";

import ChatList from "@/pages/sidebar/interact/chat/list"; // New component to create
import ChatLayout from "@/pages/sidebar/interact/chat/layout";
import ChatPage from "@/pages/sidebar/interact/chat/chat";
import ChatEmpty from "@/pages/sidebar/interact/chat/empty"; // New component to create

export const interactionRoutes = {
  path: "/interact",
  children: [
    { path: "/interact/call", element: <CallsPage /> },
    {
      path: "/interact/chat",
      element: <ChatLayout />,
      children: [
        { 
          path: "/interact/chat", 
          element: <ChatList />,
          children: [
            { index: true, element: <ChatEmpty /> },
            { path: ":userId", element: <ChatPage /> }
          ]
        },
      ],
    },
  ],
};